import { APP_RESET_ERROR, SHOW_SNACK } from '@/store/MUTATIONS-TYPES'
import axios from 'axios'
import { Component, Vue } from 'vue-property-decorator'
import { VAlert, VBtn, VCard, VCardText, VDialog, VIcon, VSpacer } from 'vuetify/lib'
import './AppErrorDialog.scss'

@Component({})
export class AppErrorDialog extends Vue {
	snackbar = false

	get state() {
		const { state } = this.$store
		return state.app.isError
	}

	get errorMessage() {
		const { state } = this.$store
		return state.app.error.message
	}

	get errorException() {
		const { state } = this.$store
		return state.app.error.exception
	}

	get isAxiosError() {
		return axios.isAxiosError(this.errorException)
	}

	public render() {
		return (
			<VDialog max-width="600" vModel={this.state} id="app-error-page" column class="fade-in">
				<VCard class="pt-6 pb-1 modalError">
					<VCardText>
						<VIcon size="32" style="mb-2">
							mdi-alert-circle-outline
						</VIcon>
						<h2>Ocorreu uma instabilidade!</h2>
						<p>
							Durante a sua consulta ocorreu uma instabilidade no sistema. Ela foi gravada e reportada automaticamente para o Time de
							Engenharia.
						</p>
						<p>
							Atualize a página e refaça sua consulta. Caso o problema persista, clique em Copiar diagnóstico e abra um chamado para o Time
							de Suporte colando as informações copiadas.
						</p>

						<button class="px-6 py-4" onClick={() => this.flushError()}>
							Fechar
						</button>

						<button class="ml-4 px-6 py-4 primary-btn" onClick={() => this.copyErrorMessage()}>
							<VIcon>mdi-content-copy</VIcon>
							Copiar diagnóstico
						</button>
					</VCardText>
				</VCard>
			</VDialog>
		)
	}

	flushError() {
		const { commit } = this.$store
		commit(APP_RESET_ERROR)
	}

	copyErrorMessage() {
		const { commit, state } = this.$store

		navigator.clipboard.writeText(JSON.stringify(state.app.error))

		commit(SHOW_SNACK, 'Copiado para área de transferência')

		this.flushError()
	}
}

export default AppErrorDialog
